import { createFileRoute } from "@tanstack/react-router";
import { ChatPage } from "../../../components/chats/chat-page";
import { openChatSearchSchema } from "../../../lib/chats/search-params";

/**
 * An earlier chat, opened. Keyed by chat, so switching chats never carries a draft across. Which
 * panel sits beside it (the Context rail, or a process on the canvas) is in the address.
 */
export const Route = createFileRoute("/_authenticated/_workspace/chats/$chatId")({
  validateSearch: openChatSearchSchema,
  component: function ChatRoute() {
    const { chatId } = Route.useParams();
    const search = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <ChatPage
        key={chatId}
        chatId={chatId}
        search={search}
        onChange={(patch) =>
          // Opening a panel is not a new page: replace the entry, and skip the page-wide transition.
          void navigate({
            search: (previous) => ({ ...previous, ...patch }),
            replace: true,
            viewTransition: false,
          })
        }
      />
    );
  },
});
